const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'María González',
      location: 'Madrid, España',
      avatar: 'MG',
      rating: 5,
      date: '15 Nov 2024',
      text: 'Servicio excepcional desde el aeropuerto hasta nuestro hotel en Marbella. El conductor fue muy profesional, el vehículo impecable y llegamos puntuales. Sin duda volveremos a usar WEAREBUS en nuestro próximo viaje a la Costa del Sol.'
    },
    {
      name: 'James Wilson',
      location: 'London, UK',
      avatar: 'JW',
      rating: 5,
      date: '12 Nov 2024',
      text: 'Outstanding service from Malaga Airport to our hotel. The driver was waiting for us with a sign, very friendly and professional. Clean and comfortable vehicle. Highly recommended for anyone visiting Costa del Sol.'
    },
    {
      name: 'Carmen Ruiz',
      location: 'Sevilla, España',
      avatar: 'CR',
      rating: 5,
      date: '10 Nov 2024',
      text: 'Perfecto para nuestra boda en Málaga. Transportaron a todos los invitados sin problemas, siempre puntuales y con vehículos elegantes. El equipo de WEAREBUS hizo que nuestro día especial fuera aún más memorable.'
    },
    {
      name: 'Paolo Rossi',
      location: 'Milano, Italia',
      avatar: 'PR',
      rating: 5,
      date: '8 Nov 2024',
      text: 'Servizio fantastico per il nostro gruppo di 12 persone. Minibus molto confortevole, autista professionale e prezzo onesto. Consiglio vivamente WEAREBUS per trasferimenti di gruppo nella Costa del Sol.'
    },
    {
      name: 'Sarah Johnson',
      location: 'New York, USA',
      avatar: 'SJ',
      rating: 5,
      date: '5 Nov 2024',
      text: 'Amazing experience! Professional driver, luxury vehicle, and perfect timing. They monitored our flight and were ready when we arrived. The best transport service we have ever used in Spain.'
    },
    {
      name: 'Luis Fernández',
      location: 'Barcelona, España',
      avatar: 'LF',
      rating: 5,
      date: '3 Nov 2024',
      text: 'Excelente servicio ejecutivo para mis reuniones de negocios en Málaga. Puntualidad absoluta, WiFi gratuito en el vehículo y conductores muy profesionales. WEAREBUS es mi primera opción para transporte empresarial.'
    },
    {
      name: 'Emma Thompson',
      location: 'Manchester, UK',
      avatar: 'ET',
      rating: 5,
      date: '1 Nov 2024',
      text: 'Wonderful service for our family holiday. Clean, comfortable vehicle with plenty of space for luggage. Driver was very helpful and gave us great tips about Malaga. Will definitely book again!'
    },
    {
      name: 'Roberto Silva',
      location: 'Porto, Portugal',
      avatar: 'RS',
      rating: 5,
      date: '28 Oct 2024',
      text: 'Serviço impecável para o nosso tour pela Costa del Sol. Motorista conhecedor da região, veículo luxuoso e preços justos. A WEAREBUS superou todas as nossas expectativas. Recomendo sem hesitação.'
    }
  ];

  return (
    <section id="testimonios" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Miles de clientes satisfechos avalan nuestro compromiso con la excelencia en el servicio de transporte
          </p>
          <div className="w-20 h-1 bg-teal-600 mx-auto mt-8"></div>
        </div>

        {/* Overall Rating */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-white rounded-2xl px-8 py-6 shadow-lg">
            <div className="mr-6">
              <div className="text-5xl font-bold text-teal-600 mb-2">5.0</div>
              <div className="flex text-yellow-400 text-xl mb-2">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
              <div className="text-gray-600 text-sm">Basado en 1,247+ reseñas</div>
            </div>
            <div className="border-l border-gray-200 pl-6">
              <img 
                src="https://lirp.cdn-website.com/bd43b07c/dms3rep/multi/opt/TripAdvisor+%281%29-1920w.png" 
                alt="TripAdvisor Choice Award" 
                className="h-16 w-16 object-contain mx-auto mb-2"
              />
              <div className="text-sm text-gray-600 font-medium">
                Choice Award 2024
              </div>
            </div>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              style={{
                marginTop: index % 3 === 1 ? '2rem' : '0'
              }}
            >
              {/* Header */}
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-gradient-to-r from-teal-500 to-teal-600 rounded-full flex items-center justify-center text-white font-bold mr-3 border-2 border-teal-200">
                    {testimonial.avatar}
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                    <div className="flex items-center text-sm text-gray-500">
                      <i className="ri-map-pin-line mr-1 text-xs"></i>
                      {testimonial.location}
                    </div>
                  </div>
                </div>
                <div className="flex text-yellow-400 text-sm">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>
              </div>

              {/* Quote */}
              <div className="relative">
                <i className="ri-double-quotes-l text-teal-600 text-2xl absolute -top-2 -left-1"></i>
                <p className="text-gray-700 leading-relaxed pl-6 mb-4 text-sm line-height-relaxed">
                  {testimonial.text}
                </p>
              </div>

              {/* Date */}
              <div className="text-xs text-gray-400 text-right">
                {testimonial.date}
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-20 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-8">
            Nuestras Certificaciones
          </h3>
          <div className="flex flex-wrap justify-center items-center gap-8 opacity-60">
            <div className="flex items-center">
              <i className="ri-shield-check-line text-3xl text-teal-600 mr-2"></i>
              <span className="font-medium text-gray-700">Licencia de Transporte</span>
            </div>
            <div className="flex items-center">
              <i className="ri-award-line text-3xl text-teal-600 mr-2"></i>
              <span className="font-medium text-gray-700">ISO 9001:2015</span>
            </div>
            <div className="flex items-center">
              <i className="ri-car-line text-3xl text-teal-600 mr-2"></i>
              <span className="font-medium text-gray-700">VTC Autorizada</span>
            </div>
            <div className="flex items-center">
              <i className="ri-customer-service-line text-3xl text-teal-600 mr-2"></i>
              <span className="font-medium text-gray-700">Atención 24/7</span>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default TestimonialsSection;